import { getDefaultEditPageItemNameEditorState } from '../../service/EditPageItemNameEditor/EditPageItemNameEditor';
import {
    EditPageItemNameEditorsState,
    EditPageItemNameEditorState
} from '../../typings/editPageItemNameEditor';

export const selectEditPageItemNameEditorValue = (
    editors: EditPageItemNameEditorsState,
    editorId: string
): EditPageItemNameEditorState => {
    return editors[editorId] || getDefaultEditPageItemNameEditorState();
};
